import { timeFrameMapping } from './widget-constants';

export const switchesWidgets = [
  {
    name: 'Switches Summary',
    dataGroup: 'wireless',
    w: 3,
    endpoint: '/devices/inventory/switches',
    component: 'donutChart',
    preview: 'donutChartPreview',
    disableTimeFrameDropdown: true,
    drillDownUrl : '/m/devices/switch',
  }, {
    name: 'Top Switches by Traffic',
    dataGroup: 'wireless',
    w: 6,
    endpoint: '/statistics/devices',
    component: 'donutChart',
    preview: 'donutChartPreview',
    timeFrameOptions: [
      timeFrameMapping.last24Hours,
      timeFrameMapping.last7Days,
      timeFrameMapping.last30Days,
    ],
    disableTimeFrameDropdown: false,
    drillDownUrl : '/m/devices/switches',
  }, {
    name: 'PoE of Switches',
    dataGroup: 'wireless',
    w: 6,
    endpoint: '/statistics/topn/all',
    component: 'donutChart',
    preview: 'donutChartPreview',
    valuesSIUnit: 'watt',
    timeFrameOptions: [
      timeFrameMapping.last24Hours,
      timeFrameMapping.last7Days,
      timeFrameMapping.last30Days,
    ],
    disableTimeFrameDropdown: false,
    drillDownUrl : '/m/devices/switches',
  },
];
